import http from '@/modules/http.js'
import decode from 'jwt-decode'
import { roles } from '@/main.config.js'

const state = {
  authUser: null
}

const getters = {
  AUTH_USER: state => state.authUser,
  HAVE_AUTH_USER: state => !!state.authUser,
  HAS_DOCTOR: state => {
    return state.authUser ? state.authUser.user_roles.indexOf(roles.doctor) !== -1 : false
  },
  HAS_HOSPITAL_ADMIN: state => {
    return state.authUser ? state.authUser.user_roles.indexOf(roles.hospital) !== -1 : false
  },
  HAS_NEURO_ADMIN: state => {
    return state.authUser ? state.authUser.user_roles.indexOf(roles.neuro) !== -1 : false
  },
  HAS_READONLY: state => {
    return state.authUser ? state.authUser.user_roles.indexOf(roles.readonly) !== -1 : false
  },
  IS_HIMSELF: state => id => {
    return parseInt(state.authUser.id, 10) === parseInt(id, 10)
  }
}

const actions = {
  LOAD_AUTH_USER(context) {
    return new Promise((resolve, reject) => {
      if (!context.getters.GET_TOKEN || context.state.authUser) {
        resolve({ status: 'exist' })
      }
      const payload = decode(context.getters.GET_TOKEN)
      http
        .get('/users/' + payload.userId)
        .then(response => {
          context.commit('SET_AUTH_USER', response.data)
        })
        .then(() => resolve({ status: 'ok' }))
        .catch(error => {
          reject(error)
        })
    })
  },
  HAS_RIGHTS: (context, allowedRoles) => {
    return new Promise((resolve, reject) => {
      if (context.state.authUser == null) {
        reject()
      }

      const userRoles = context.state.authUser.user_roles
      userRoles.forEach(userRole => {
        if (allowedRoles.indexOf(userRole) !== -1) {
          resolve()
        }
      })
      reject()
    })
  }
}

const mutations = {
  SET_AUTH_USER: (state, payload) => {
    state.authUser = payload
  },
  CLEAR_AUTH_USER: state => {
    state.authUser = null
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
